import {
  Container, Box, Grid, Link, Button
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';

export const DownloadGuide = () => {
  const classes = useStyles();
  const history = useHistory();

  const signDocumentHandler = () => {
    history.push('/donor-agreement');
  };

  const onBackHandler = () => {
    history.goBack();
  };

  return (
    <Container maxWidth="md" className={classes.mainWrapper}>
      <Box className={classes.root}>
        <Grid container rowSpacing={{ xs: 4, sm: 5, md: 5 }} justifyContent="center">
          <Grid item xs={12}>
            <Box className={classes.titleWrapper}>
              <Box className={classes.title}>Avoid Common Drug Testing Issues!</Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <ErrorIcon className={classes.errorIconImage} />
            </Box>
          </Grid>
          <Grid item xs={9} md={7} className={classes.gridItem}>
            <Box>
              <Box className={classes.description}>
                You are responsible for the substances that you consume. Some foods and medications may cross-react and result in false positive drug screens or dilute samples. When in doubt, obtain permission from the court or consult your counselor or probation officer.
              </Box>
            </Box>
          </Grid>
          <Grid item xs={8} md={12}>
            <Box>
              <Link className={classes.medicationLink} href="assets/pdfFiles/Cross_Reactivity_Guidelines.pdf" download>
                Download Medication Reference Guide
              </Link>
            </Box>
          </Grid>
          <Grid item xs={8} md={12}>
            <Box>
              <Link className={classes.medicationLink} href="assets/pdfFiles/Dilute_Guidelines.pdf" download>
                Download Dilution Guidelines
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box className={classes.root}>
              <Grid container rowSpacing={{ xs: 3, sm: 3, md: 0 }} justifyContent="center">
                <Grid item xs={8} md={4} >
                  <Box px={2} className={classes.secondaryBtnWrapper}>
                    <Button variant="contained" color="primary" onClick={signDocumentHandler}>
                      Sign Document (0/3)
                    </Button>
                  </Box>

                </Grid>
                <Grid item xs={8} md={4} >
                  <Box px={2} className={classes.primaryBtnWrapper}>
                    <Button variant="contained" color="secondary" onClick={onBackHandler}>
                      Back
                    </Button>
                  </Box>

                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

    </Container>
  );
};
